import PropTypes from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchReviewsCoverPhoto } from "slices/reviews-cover-photo-slice";
import ReviewImagesWithMemberInfo from "./review-images-with-member-info";

export default function FeaturedReviewImageCarousel(props) {
  const dispatch = useDispatch();
  const reviewsCoverPhotos = useSelector(state => state.reviewsCoverPhotos);
  const hasReviewCoverPhotoForStyle =
    Array.isArray(reviewsCoverPhotos) &&
    reviewsCoverPhotos.length > 0 &&
    reviewsCoverPhotos[0]?.styleName === props.productId; // this extra clause is to support product drawers

  useEffect(() => {
    if (!hasReviewCoverPhotoForStyle) {
      dispatch(fetchReviewsCoverPhoto({ productId: props.productId, isFeatured: true }));
    }
  }, []);

  if (!hasReviewCoverPhotoForStyle) {
    return;
  }

  return (
    <div
      className={`featured-review-image-carousel ${
        reviewsCoverPhotos.length === 1 ? "featured-review-image-carousel--single-child" : ""
      }`}
      data-test-id="featured-review-image-carousel">
      <ReviewImagesWithMemberInfo reviewsCoverPhotos={reviewsCoverPhotos} />
    </div>
  );
}

FeaturedReviewImageCarousel.propTypes = {
  productId: PropTypes.string,
};
